const PROXY_ENDPOINT = '/api/proxy'

export function getProxiedUrl(targetUrl: string): string {
  return `${PROXY_ENDPOINT}?url=${encodeURIComponent(targetUrl)}`
}

export function proxyFetch(url: string, options?: RequestInit): Promise<Response> {
  const proxyUrl = getProxiedUrl(url)
  return fetch(proxyUrl, options)
}
